module.exports = __webpack_public_path__ + "files/df67915158e69d76588a3e3934c955f9.png";